/**
 * Configuración centralizada de Komity
 * Reemplaza a config.json usando variables de entorno (.env)
 * Compatible con Create React App (REACT_APP_*)
 */

const R2_PUBLIC_URL = process.env.REACT_APP_R2_PUBLIC_URL || 'https://pub-2c1836fc148347efa9ce9300e0bb3cb5.r2.dev';

const config = {
    // URL base de la API
    api_url: process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000',

    // Ruta de imagen por defecto para productos sin foto
    img_defecto: process.env.REACT_APP_IMG_DEFECTO || '/imgs/defecto.png',

    // URL pública de Cloudflare R2 para imágenes de productos
    r2_public_url: R2_PUBLIC_URL,

    // API Key de Google Maps
    google_api: process.env.REACT_APP_GOOGLE_API_KEY || '',
};

// Arma la URL pública de una imagen guardada en R2 a partir del key
// devuelto por el backend. Si `key` ya es una URL absoluta, la retorna igual.
export const resolveImagenUrl = (key) => {
    if (!key) return null;
    if (key.startsWith('http')) return key;
    const keyLimpio = key.startsWith('/') ? key.substring(1) : key;
    return `${R2_PUBLIC_URL}/${keyLimpio}`;
};

export default config;